import { Dialog, DialogContent, DialogTrigger } from "src/components/dialogue/radix-dialog"
import AddProductForm from "./AddProductForm";
import { useState } from "react";
import { Product } from "../../types/products";


const AddProductModal = ({
  children,
  onProductCreated,
}: {
  children: React.ReactNode;
  onProductCreated: (product: Product) => void;
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white max-w-5xl max-h-[70vh] w-full">
        <div>
          <div className="p-8 border-b border-slate-100 flex justify-between items-center bg-slate-50">
            <div className="flex flex-col">
              <h3 className="text-2xl font-black text-slate-900 uppercase tracking-tight">
                Add Inventory Asset
              </h3>
              <p className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest mt-1">
                Add Product
              </p>
            </div>
          </div>
          <AddProductForm
            close={handleClose}
            onProductCreated={onProductCreated}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddProductModal